<template>
	<v-theme-provider>
		<v-card
			class="mx-auto elevation-20"
			color="white"
			style="max-width: 400px;"
			shaped
		>
			<v-row justify="space-between" no-gutters>
				<v-card-text>
					<v-col cols="12" md="12" sm="12" class="text-center">
						<v-rating
							v-model="stars"
							color="primary"
							dense
							readonly
							half-increments
							hover
							size="36"
						></v-rating>
					</v-col>
					<v-col cols="12" md="12" sm="12">
						<p class="text-center">
							{{ review }}
						</p>
					</v-col>
				</v-card-text>
			</v-row>
			<v-divider dark></v-divider>
			<v-card-actions class="pa-4 ">
				{{ name }}
				<v-spacer></v-spacer>
				{{ date }}
			</v-card-actions>
		</v-card>
	</v-theme-provider>
</template>

<script>
export default {
	name: 'BaseReviewCard',
	props: {
		dark: Boolean,
		name: String,
		date: String,
		color: {
			type: String,
			default: 'primary',
		},
		review: String,
		stars: Number,
	},
	data: () => ({}),
}
</script>
